import React, { useEffect, useState } from "react";
import intl from 'react-intl-universal';
import { isDTRuntime } from "@/modules/dingtalk/dingtalk.sdk";
import SearchSelectUser, { SelectUserItem } from "../SearchSelectUsers/SearchSelectUsers";
import store from "@/store";
import { promise2ErrorFirst } from "@/modules/dingtalk/dingtalk.util";
import {
    ADD_MORE_PEOPLE_FAILED,
    ADD_MORE_PEOPLE_SUCCESS
} from "@/components/viewer/ui/constants/user.more.constants";
import "./DingtalkShareAction.scss";
import { SendButton } from "../../widgets/widgets";
import { InviteData, InviteItem } from "../types";
import DingtalkNotifyAPI from "@/modules/dingtalk/apis/notify";
import { ShareDocParams } from "@/modules/dingtalk/dtos/notify";
import { bindBeforeCreateShareLinkOrSendShareEmail } from "@/modules/dingtalk/utils/utils";

export default function DingtalkShareAction({
    inviteData,
    closeMainArea,
    onSuccess,
    onShow
}: {
    inviteData: Omit<InviteData, 'userId'>;
    closeMainArea?: boolean;
    onSuccess: () => any;
    onShow: () => any;
}) {
    if (!isDTRuntime) return null;
    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [list, setList] = useState<SelectUserItem[]>([]);

    async function onSelectChange(list: SelectUserItem[]) {
        setList(list);
    }
    function toggle() {
        setVisible(!visible);
    }
    async function beforeSend() {
        setLoading(true);
        const status = await inviteJoinAndNotify({
            cDocID: inviteData.cDocID,
            reviewSessionID: inviteData.reviewSessionID,
            doc_name: inviteData.docName,
            fileLink: inviteData.fileLink,
            userList: list.map<InviteItem>(item => ({ userId: item.id, prohibitComment: item.permit }))
        });
        setLoading(false);
        if (status) {
            onSuccess();
        }
    }
    useEffect(() => {
        if (closeMainArea) {
            setVisible(!closeMainArea);
        }
    }, [closeMainArea]);
    useEffect(() => {
        if (visible) {
            onShow();
        }
    }, [visible]);

    return (
        <div className="dd-share__action">
            <div className="dd-share__action-title" onClick={toggle}>
                <span className="dd-share__icon"></span>
                <span style={{ marginLeft: 12 }}>通过钉钉用户名共享</span>
            </div>
            {visible &&
                <div className="dd-share__action-main">
                    <SearchSelectUser onChange={onSelectChange} />
                    <SendButton
                        className="dd-share__send"
                        disabled={!list.length || loading}
                        onClick={bindBeforeCreateShareLinkOrSendShareEmail(beforeSend)}
                    />
                </div>
            }
        </div >
    )
}

async function inviteJoinAndNotify(sendData: ShareDocParams) {
    const [err, res] = await promise2ErrorFirst(DingtalkNotifyAPI.shareDocAndNotify(sendData));
    if (err) {
        store.appStore.setGlobalMessage({ type: 'success', content: intl.get('collaboration.sharedList.SharedTableAction.sendFailed') });
        return false;
    }
    const { ret, data, message } = res as any;
    if (ret === 0) {
        store.userStore.doSendGAEventByUserEvent(ADD_MORE_PEOPLE_SUCCESS, null, null);
        store.appStore.setGlobalMessage({ type: 'success', content: intl.get('collaboration.sharedList.SharedTableAction.sendSuccessful') })
        return true;
    }
    if (ret === 110015) {
        store.appStore.setGlobalMessage({ type: 'error', content: intl.get("collaboration.Error.limitOnInvite", { limitNum: data[0].limitUserCount }) })
    } else {
        store.appStore.setGlobalMessage({ type: 'error', content: message });
    }
    store.userStore.doSendGAEventByUserEvent(ADD_MORE_PEOPLE_FAILED, null, null);
    store.appStore.setGlobalMessage({ type: 'success', content: intl.get('collaboration.sharedList.SharedTableAction.sendFailed') })
    return false;
}
